import { Dialog, DialogProps } from "../../core/components/dialog";
import { FieldInstance } from "../../core/components/field";
import { IsNumericTextBox } from "../../core/components/isNumericTextBox";
import { TextBox } from "../../core/components/textBox";
import { Config } from "../../core/config/config";
import { ComponentHelper } from "../../core/util/componentHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslationsInGrid, { ContainsLanguage } from "../editTranslationsInGrid";
import { Skill } from "./skillsInterfaces";
import React from "react";
import ReactDOM from "react-dom";
export const openEditSkill = (skill: Skill, usePrio: boolean) => {
    return new Promise<EditSkillResult>((resolve, reject) => {
        const targetElement = $("<div>");
        const root = ReactDOM["createRoot"](targetElement[0]);
        const props: EditSkillProps = {
            skill: skill,
            usePrio: usePrio,
            isNew: !Helper.hasValue(skill),
            onOk: (result: EditSkillResult) => {
                if (Helper.hasValue(result.skill.Rtext))
                    resolve(result);
                else
                    NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ContainerFilter.EmptyName"));
            },
            onCancel: () => {
                root.unmount();
            }
        }
        $("body").append(targetElement);
        root.render(<EditSkillGeneralSettings {...props} />);
    })
}

interface EditSkillProps {
    skill: Skill;
    usePrio: boolean;
    isNew: boolean;
    onOk: (data: EditSkillResult) => void;
    onCancel: () => void;
}

interface EditSkillState {
    skillTranslations: DefaultTranslationInGrid[];
    skill: Skill;
}

export interface EditSkillResult {
    translations: DefaultTranslationInGrid[];
    skill?: Skill;
}

export class EditSkillGeneralSettings extends React.Component<EditSkillProps, EditSkillState> {
    private kendoDialogRef: kendo.ui.Dialog;
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.onCancel();
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.props.onOk({ translations: this.state.skillTranslations, skill: this.state.skill });
                },
                primary: true
            }
        ],
        afterClose: () => {
        },
        width: 500
    };

    constructor(props) {
        super(props)
        this.state = {
            skillTranslations: [],
            skill: { IsNew: this.props.isNew }
        }
    }

    componentDidMount() {
        if (!this.props.isNew)
            this.loadData();
    }

    loadData = async () => {
        let result = await HTTPService.chainBatch
            .add(HTTPService.get<JsonResultClass>(`EditSkill/GetSkillTranslations?fid=${this.props.skill.Fid}&rIndex=${this.props.skill.Rindex}`))
            .promise();

        let skillTranslations = JSON.parse(JSON.stringify(result[0].Data));

        this.setState({ skill: this.props.skill, skillTranslations: skillTranslations });
    }

    private getNameTextBoxProps = () => {
        let textBoxProps = this.factory.getDefaultTextBoxProps();
        textBoxProps.value = this.state.skill.Rtext;
        textBoxProps.disabled = !this.props.isNew;
        textBoxProps.required = true;
        textBoxProps.onChange = (_, value: string) => {
            let skill = this.state.skill;
            skill.Rtext = value;
            this.setState({ skill: skill });
        };
        return textBoxProps;
    }

    private getNumericDropDownPrio = () => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.skill.Prio;
        props.field.min = 0;
        props.field.max = Config.settings.skills.maxPriorityValue;
        props.onChange = (_, value) => {
            let skill = this.state.skill;
            skill.Prio = value;
            this.setState({ skill: skill });
        }
        return (<FieldInstance label={Helper.getTranslation("Standard.Priority")} >
            <IsNumericTextBox {...props} />
        </FieldInstance>);
    }

    private getNumericDropDown = (fieldName: string, title: string) => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.skill[fieldName];
        props.onChange = (_, value) => {
            let skill = this.state.skill;
            skill[fieldName] = value;
            this.setState({ skill: skill });
        }
        return (<FieldInstance label={title} >
            <IsNumericTextBox {...props} />
        </FieldInstance>);
    }

    private getHeader = (text: string) => {
        return <label style={{ marginLeft: "5px", fontWeight: "bold" }}>{text}</label>;
    }

    renderEditTranslationsInGrid = () => {
        let translationColumns = [
            {
                visible: true,
                width: "100",
                field: "Translation",
                title: Helper.getTranslation("Field.Ressource.name")
            }
        ];

        return <EditTranslationsInGrid
            id={"editSkillTreeCategoryTranslationsInGrid"}
            gridData={this.state.skillTranslations}
            translationColumns={translationColumns}
            onDataLoaded={() => this.kendoDialogRef.center()} />
    }

    private getDialog(usePrio: boolean) {
        return <Dialog {...this.dialogProps} open={true} dialogInternalRef={(ref) => this.kendoDialogRef = ref} width={"800px"}>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <FieldInstance label={Helper.getTranslation("Standard.Designation")} required={false} >
                    <TextBox {...this.getNameTextBoxProps()} />
                </FieldInstance>
                <div style={{ marginTop: "10px" }}>
                    {this.getHeader(Helper.getTranslation("Skills.Uebersetzungen"))}
                    {this.renderEditTranslationsInGrid()}
                </div>
                <div style={{ marginTop: "10px" }}>
                    {usePrio ? this.getHeader(Helper.getTranslation("Server.Allgemein")) : null}
                    {usePrio ? this.getNumericDropDownPrio() : null}
                    {this.getNumericDropDown("Order", Helper.getTranslation("Skills.Order"))}
                </div>
            </div>
        </Dialog>
    }

    render() {
        let dialog = Helper.hasValue(this.state.skill) ? this.getDialog(this.props.usePrio) : null;
        return (dialog);
    }
}
export interface DefaultTranslationInGrid extends ContainsLanguage {
    Translation?: string;
}